import { render, staticRenderFns } from "./InterventionEditor.vue?vue&type=template&id=a955a36c"
import script from "./InterventionEditor.vue?vue&type=script&lang=js"
export * from "./InterventionEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports